import { DiscountRestriction } from '@vista-digital/ocapi-types/v1';
import { getDiscountById } from '../../../sales-data/selectors/discounts/get-discount-by-id';
import { getItemById } from '../../../sales-data/selectors/items/get-item-by-id';
import { getLowestItemPrice, isDiscountItemPrice, isDiscountOrMemberRewardItemPrice, isMemberRewardItemPrice } from '../../../sales-data/utils/items/item-price-utils';
import { assertIsNormalItem } from '../../../sales-data/utils/items/item-type-utils';
import { getInProgressParentSalesOptions } from '../../utils/items/get-in-progress-parent-sales-options';
import { getAllowedOrderItemQuantityForRestrictedPrice } from './get-allowed-order-item-quantity-for-restricted-price';
import { getInProgressParentSalesItemOptionCount } from './get-in-progress-parent-sales-item-option-count';
import { getOrderItemCount } from './get-order-item-count';
import { getPriceRestrictionFromItemPrice } from './get-price-restriction-from-item-price';
export const getAllowedOrderParentSalesOptionQuantity = (itemOption, maximumItemsPerOrder) => {
    var _a;
    const item = getItemById(itemOption.itemId);
    assertIsNormalItem(item, `Cannot get allowed quantity for item with ID: ${itemOption.itemId}`); // Only supporting normal item as option item.
    const inProgressSelectedOptions = getInProgressParentSalesOptions();
    const option = inProgressSelectedOptions[item.id];
    const selectedOptionCount = (_a = option === null || option === void 0 ? void 0 : option.quantity) !== null && _a !== void 0 ? _a : 0;
    const remainingAdditionForOption = getRemainingAdditionForOption(itemOption, maximumItemsPerOrder, inProgressSelectedOptions, option);
    const quantity = {
        max: remainingAdditionForOption + selectedOptionCount,
        selectedQuantity: selectedOptionCount
    };
    return quantity;
};
const getRemainingAdditionForOption = (itemOption, maximumItemsPerOrder, inProgressSelectedOptions, option) => {
    var _a;
    const inProgressOptionCount = getInProgressParentSalesItemOptionCount();
    const remainingAdditionsForAllParentSalesOptions = maximumItemsPerOrder - inProgressOptionCount - getOrderItemCount();
    const itemPrice = (_a = option === null || option === void 0 ? void 0 : option.item.selectedPrice) !== null && _a !== void 0 ? _a : getLowestItemPrice(itemOption.prices);
    if (!isDiscountOrMemberRewardItemPrice(itemPrice)) {
        return remainingAdditionsForAllParentSalesOptions;
    }
    const totalAvailableRestrictedOptions = getAllowedOrderItemQuantityForRestrictedPrice(itemPrice, itemOption.itemId, false);
    if (totalAvailableRestrictedOptions) {
        const restrictedInProgressOptionCount = getPriceRestrictedInProgressOptionCount(inProgressSelectedOptions, itemPrice);
        const remainingAdditionForPriceRestrictedOption = totalAvailableRestrictedOptions - restrictedInProgressOptionCount;
        const minAllowed = Math.min(remainingAdditionForPriceRestrictedOption, remainingAdditionsForAllParentSalesOptions);
        return minAllowed;
    }
    return remainingAdditionsForAllParentSalesOptions;
};
export const getPriceRestrictedInProgressOptionCount = (selectedInProgressItems, itemPrice) => {
    const count = Object.values(selectedInProgressItems).reduce((total, option) => {
        const priceRestriction = getPriceRestrictionFromItemPrice(option.item.selectedPrice);
        if (isDiscountItemPrice(itemPrice)) {
            total += getDiscountedInProgressOptionCount(itemPrice, option, priceRestriction);
        }
        if (isMemberRewardItemPrice(itemPrice)) {
            total += getMemberRewardInProgressOptionCount(itemPrice, option, priceRestriction);
        }
        return total;
    }, 0);
    return count;
};
const getDiscountedInProgressOptionCount = (itemPrice, option, priceRestriction) => {
    if (itemPrice.discountId === (priceRestriction === null || priceRestriction === void 0 ? void 0 : priceRestriction.discountId))
        return option.quantity;
    const discount = getDiscountById(itemPrice.discountId);
    if ((priceRestriction === null || priceRestriction === void 0 ? void 0 : priceRestriction.rewardId) &&
        (discount === null || discount === void 0 ? void 0 : discount.restriction.includes(DiscountRestriction.MemberReward)) &&
        discount.rewardIds.includes(priceRestriction.rewardId)) {
        return option.quantity;
    }
    return 0;
};
const getMemberRewardInProgressOptionCount = (itemPrice, option, priceRestriction) => {
    if (itemPrice.rewardId === (priceRestriction === null || priceRestriction === void 0 ? void 0 : priceRestriction.rewardId))
        return option.quantity;
    if (priceRestriction === null || priceRestriction === void 0 ? void 0 : priceRestriction.discountId) {
        const discount = getDiscountById(priceRestriction.discountId);
        if ((discount === null || discount === void 0 ? void 0 : discount.restriction.includes(DiscountRestriction.MemberReward)) &&
            discount.rewardIds.includes(itemPrice.rewardId)) {
            return option.quantity;
        }
    }
    return 0;
};
